import { css } from '@emotion/core';

export const base = css`
  text-transform: capitalize;
`;
